import { useState, ChangeEvent } from "react";
import uploadFile from "../../../utils/uploadFiles";

const useBriefImageUpload = (initialUrl = "") => {
  const [imageUrl, setImageUrl] = useState<string>(initialUrl);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setUploadError("");
    setIsUploading(true);
    const fileReader = new FileReader();
    fileReader.onload = () => {
      uploadFile({
        file: fileReader.result as string,
        folder: "artists-briefs",
        upload_preset: "Bezalel_preset",
      })
        .then((url) => setImageUrl(url as string))
        .catch((error) => {
          console.error("Image upload failed", error);
          setUploadError("Image upload failed. Please try again.");
        })
        .finally(() => setIsUploading(false));
    };
    fileReader.onerror = () => {
      setUploadError("Could not read the selected file.");
      setIsUploading(false);
    };
    fileReader.readAsDataURL(file);
  };

  return { imageUrl, isUploading, uploadError, handleFileChange };
};

export default useBriefImageUpload;
